// extracted by mini-css-extract-plugin
module.exports = {"flightInfo":"flightInfo-1phf9","group":"group-2fu0b","footer_group":"footer_group-3DFVj","airline":"airline-3FBz3","links":"links-2FA0b"};